export default __webpack_public_path__ + "static/media/lipstick-cold-summer.af10bea6.png";